import { useEffect } from "react";
import PropTypes from "prop-types";
import DeliveryNoteExportSheet from "./DeliveryNoteExportSheet";
import useDeliveryNoteDocument from "./useDeliveryNoteDocument";
import useDeliveryNotePdfExport from "./useDeliveryNotePdfExport";

const DeliveryNoteSavedNoteExport = ({ note, onDone }) => {
  const { template, snapshot, resolveImage, documentNote, isReady } =
    useDeliveryNoteDocument(note);
  const { isExporting, exportRef, exportPdf } = useDeliveryNotePdfExport();

  useEffect(() => {
    if (!isReady) return undefined;
    let isCurrent = true;
    const timer = setTimeout(async () => {
      await exportPdf({ template, number: note.number });
      if (isCurrent) onDone();
    });
    return () => {
      isCurrent = false;
      clearTimeout(timer);
    };
  }, [isReady, exportPdf, template, note.number, onDone]);

  if (!isExporting) return null;

  return (
    <DeliveryNoteExportSheet
      snapshot={snapshot}
      resolveImage={resolveImage}
      note={documentNote}
      sheetRef={exportRef}
    />
  );
};

DeliveryNoteSavedNoteExport.propTypes = {
  note: PropTypes.object.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default DeliveryNoteSavedNoteExport;
